import React from 'react'
import { getPainterEventAddress } from './eventUtils'
import type { PainterScheduleEvent } from './types'
import type { usePainterWorkOrderStyles } from './usePainterWorkOrderStyles'

interface ContactCardProps {
  event: PainterScheduleEvent
  showClientInfo: boolean
  classes: ReturnType<typeof usePainterWorkOrderStyles>
}

export default function ContactCard({ event, showClientInfo, classes }: ContactCardProps) {
  const contact = event.contact
  const address = getPainterEventAddress(event)
  if (!showClientInfo && !address) return null
  return (
    <div className={classes.contactCard}>
      {showClientInfo && contact?.name && <div className={classes.contactName}>{contact.name}</div>}
      <div className={classes.contactDetails}>
        {address && <div>{address}</div>}
        {showClientInfo && contact?.phone && <div>{contact.phone}</div>}
        {showClientInfo && contact?.email && <div>{contact.email}</div>}
      </div>
    </div>
  )
}
